export default __webpack_public_path__ + "static/media/gallery-wip-motor-housing-assembly_04.551e4fa4.jpg";